import React from "react";
import { makeStyles, ButtonBase, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import clsx from "clsx";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "5px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#ffffff",
    border: "1px solid #c4c4c4",
    borderRadius: "4px",
    width: "100%",
    height: 43,
  },
  inputText: {
    fontSize: "1rem",
    color: "#A4A6A8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

export default function PrizeTypeSelectComponent({
  anchorRef,
  handleClick,
  value,
  disabled,
  prizeTypes,
  lang,
}) {
  const classes = useStyle();

  const getDisplay = () => {
    let display = getLang(lang, "placeholder.SELECT_PRIZE_TYPE");
    if (value != null) {
      let type = prizeTypes.find((p) => {
        switch (value.prizeType) {
          case 1:
            return p.type === "item";
          case 3:
            return p.type === "redemption";
          case 4:
            return p.type === "loyalty";
          case 2:
            return (
              Number(p.disbursement_id) === Number(value.disbursementCompanyId)
            );
          default:
            return false;
        }
      });
      if (type) {
        display = type.provider_name;
      }
    }
    return display;
  };

  return (
    <ButtonBase
      className={classes.root}
      disableRipple
      ref={anchorRef}
      onClick={handleClick}
      disabled={disabled}
    >
      <Typography
        variant="body2"
        className={clsx(
          classes.inputText,
          getDisplay() !== getLang(lang, "placeholder.SELECT_PRIZE_TYPE") &&
            classes.filled
        )}
      >
        {getDisplay()}
      </Typography>
      <ArrowDropDownIcon fontSize="small" />
    </ButtonBase>
  );
}
